<!-- operational-reports.component.html -->
<div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <li class="active"><a>Operational Reports</a></li>
  </ul>
  <div class="right">
    <span>{{today}}</span>
  </div>
</div>
<div class="Content_outer">
  <ul ngbNav #ctdTabset="ngbNav" class="nav nav-tabs custom_tab" [(activeId)]="activeTab" (navChange)="onTabChange($event)">
    <li [ngbNavItem]="'audit'" id="audit">
      <a ngbNavLink>Audit Log</a>
      <ng-template ngbNavContent>
        <!-- Content for Audit Reports -->
      </ng-template>
    </li>
    <li [ngbNavItem]="'error-log'"  id="error-log">
      <a ngbNavLink>Anomaly Log</a>
      <ng-template ngbNavContent>
        <!-- Content for Error Log -->
      </ng-template>
    </li>
    <li [ngbNavItem]="'service-logs'" id="service-logs">
      <a ngbNavLink>Service Log</a>
      <ng-template ngbNavContent>
        <!-- Content for Service Log -->
      </ng-template>
    </li>
  </ul>
  <div class="operational-reports-content">
    <router-outlet></router-outlet>
  </div>
</div>

